var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('modal-monitroing-event', {
    attrs: {
      "active": _vm.monitoring,
      "event": _vm.subject,
      "events": _vm.events,
      "sort": _vm.sort,
      "selectTab": _vm.selectTab
    },
    on: {
      "close": _vm.hideModal,
      "sort": _vm.setSort
    }
  })
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-f5d15da6","hasScoped":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/modules/modal/ModalMonitoringEvent/ModalMonitoringEventContainer.vue
// module id = 897
// module chunks = 0